
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { Alert } from '@/components'
import { SaveButton } from '@/components/buttons'

export default Vue.extend({
   name: 'LogUserOut',
   props: { schoolId: String, editingItem: Object as () => PartyIdentityUserDto },
   data() {
      return {
         processing: false,
         processed: false,
      }
   },
   methods: {
      async action() {
         this.processing = true
         try {
            await Api.logUserOut(this.editingItem.Id)
            this.processed = true
         } finally {
            this.processing = false
         }
      },
   },
   components: {
      Alert,
      SaveButton,
   },
})
